// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import CVNavbar from './components/CVNavbar';
import Hero from './components/Hero';
import About from './pages/Expertise';
import Projects from './pages/Projects';
import Contact from './pages/Contact';
import Login from './pages/Login';
import CVHome from './pages/CVHome';

export default function App() {
  return (
    <Router>
      <Routes>
        {/* Caravan booking routes */}
        <Route
          path="/caravanbooking/*"
          element={
            <>
              <CVNavbar />
              <main className="pt-20">
                <Routes>
                  {/* Redirect base to login */}
                  <Route path="" element={<Navigate to="login" replace />} />
                  <Route path="login" element={<Login />} />
                  <Route path="home" element={<CVHome />} />
                  <Route path="*" element={<Navigate to="login" replace />} />
                </Routes>
              </main>
            </>
          }
        />

        {/* Portfolio routes */}
        <Route
          path="/*"
          element={
            <>
              <Navbar />
              <main className="pt-20">
                <section id="home"><Hero /></section>
                <section id="expertise"><About /></section>
                <section id="projects"><Projects /></section>
                <section id="contact"><Contact /></section>
              </main>
            </>
          }
        />
      </Routes>
    </Router>
  );
}